var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bsh-datatable',{attrs:{"columns":_vm.columns,"link":_vm.$url+'/api/adm/item-materiais/datatable/'+_vm.$route.params.id,"sorting":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }